import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { PoliciesCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { PoliciesTable } from "./table";

export default function Policies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Politiques d'accès");
  }, []);

  return (
    <Routes>
      <Route index element={<PoliciesTable />} />

      <Route path=":id" element={<PoliciesCard />} />
    </Routes>
  );
}
